import styled from '@emotion/styled';
import { Checkbox, TableRow as MUITableRow, Tooltip } from '@mui/material';
import moment from 'moment';
import tw from 'twin.macro';

import { DATE_TIME_FORMAT, REPORT_STATUS_MAP } from '../../../constants';
import { IconButton } from '../../Shared';
import { TableBodyCell } from './TableBodyCell';
import { TableCellDate } from './TableCellDate';
import { TableCellStatus } from './TableCellStatus';

const StyledCheckbox = styled(Checkbox)`
  ${tw`!p-0 w-6 h-6 text-base-600`}

  .MuiSvgIcon-root {
    ${tw`w-[24px] h-[24px]`}
  }

  &.Mui-checked {
    ${tw`text-brand-500`}
  }
`;

const getFormattedDate = (date, time) =>
  moment(
    `${moment(date).format(DATE_TIME_FORMAT.YYYY_MM_DD_DASH)} ${time}`,
    'YYYY-MM-DD hh:mm A',
  );

export const TableRow = ({
  report,
  isRowChecked,
  withBorderBottom,
  isManager,
  onSelectRow,
  openActivityLogModal,
  openRescheduleDemoModal,
  onChangeReports,
  filterByStatuses,
}) => {
  const {
    Status,
    DateBookedFor,
    TimeBookedFor,
    RescheduledDate,
    RescheduledTime,
  } = report;
  const isReportStatusScheduled = Status === REPORT_STATUS_MAP.SCHEDULED;
  const scheduledBookingDate = getFormattedDate(DateBookedFor, TimeBookedFor);
  const hasRescheduledBookingDate = !!RescheduledDate && !!RescheduledTime;
  const isScheduledBookingDatePast =
    isReportStatusScheduled &&
    !hasRescheduledBookingDate &&
    moment().isAfter(scheduledBookingDate);
  const isRescheduledBookingDatePast =
    isReportStatusScheduled &&
    hasRescheduledBookingDate &&
    moment().isAfter(getFormattedDate(RescheduledDate, RescheduledTime));

  return (
    <MUITableRow>
      {isManager && (
        <>
          <TableBodyCell withBorderBottom={withBorderBottom}>
            <StyledCheckbox
              color="primary"
              checked={isRowChecked}
              onChange={() => {
                onSelectRow(report.ApptID);
              }}
              disableRipple
            />
          </TableBodyCell>
          <TableBodyCell withBorderBottom={withBorderBottom}>
            {report.FullName}
          </TableBodyCell>
        </>
      )}
      <TableCellDate
        date={moment(report.TimeStampOfBooking).format(
          DATE_TIME_FORMAT.MM_DD_YYYY,
        )}
        time={moment(report.TimeStampOfBooking).format(DATE_TIME_FORMAT.h_mm_A)}
        className="font-normal"
        withBorderBottom={withBorderBottom}
      />
      <TableCellDate
        date={moment(DateBookedFor).format(DATE_TIME_FORMAT.MM_DD_YYYY)}
        time={TimeBookedFor}
        withBorderBottom={withBorderBottom}
        isPast={isScheduledBookingDatePast}
      />
      <TableCellDate
        date={moment(RescheduledDate).format(DATE_TIME_FORMAT.MM_DD_YYYY)}
        time={RescheduledTime}
        withBorderBottom={withBorderBottom}
        isPast={isRescheduledBookingDatePast}
      />
      <TableBodyCell withBorderBottom={withBorderBottom}>
        {report.ApptType}
      </TableBodyCell>
      <TableBodyCell withBorderBottom={withBorderBottom}>
        {report.CompanyName}
      </TableBodyCell>
      <TableBodyCell withBorderBottom={withBorderBottom}>
        {report.ContactName}
      </TableBodyCell>
      <TableBodyCell withBorderBottom={withBorderBottom} className="max-w-80">
        {report.ContactTitle}
      </TableBodyCell>
      <TableCellStatus
        withBorderBottom={withBorderBottom}
        status={Status}
        leadID={report.LeadID}
        apptID={report.ApptID}
        onChangeReports={onChangeReports}
        filterByStatuses={filterByStatuses}
      />
      <TableBodyCell align="center" withBorderBottom={withBorderBottom}>
        <div className="flex gap-4 w-fit">
          <Tooltip title="Activity Log" placement="top">
            <span>
              <IconButton
                buttonProps={{
                  className: 'w-8 h-8',
                  onClick: () => {
                    openActivityLogModal(report.ApptID);
                  },
                }}
                iconProps={{
                  name: 'clock',
                  className: 'h-5',
                }}
              />
            </span>
          </Tooltip>
          <Tooltip title="Reschedule" placement="top">
            <span>
              <IconButton
                buttonProps={{
                  className: 'w-8 h-8',
                  onClick: () => {
                    openRescheduleDemoModal(report);
                  },
                }}
                iconProps={{
                  name: 'calendar',
                  className: 'h-5',
                }}
              />
            </span>
          </Tooltip>
        </div>
      </TableBodyCell>
    </MUITableRow>
  );
};
